import React, { useState } from 'react';
import { config } from '../config';
import axios from 'axios';

function Support() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null); // null | 'sending' | 'success' | 'error'

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('sending');
    try {
      const res = await axios.post(
        `${config.getBackendUrl()}/contact`, 
        form
      )
      
      setStatus('success');
      setForm({ name: '', email: '', message: '' });
    } catch {
      setStatus('error');
    }
  };

  return (
    <div className="center-container">
      <div className="card">
        <h1>Support</h1>
        <p style={{ color: '#666', marginBottom: '24px' }}>
          For any questions, inquiries, or comments about the app, send me a message below.
        </p>
        <form onSubmit={handleSubmit}>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="name">Name</label>
            <input
              id="name"
              name="name"
              type="text"
              className="input"
              value={form.name}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="email">Email</label>
            <input
              id="email"
              name="email"
              type="email"
              className="input"
              value={form.email}
              onChange={handleChange}
              required
            />
          </div>
          <div className="field-wrapper">
            <label className="field-label" htmlFor="message">Message</label>
            <textarea
              id="message"
              name="message"
              className="input"
              value={form.message}
              onChange={handleChange}
              required
              rows={5}
              style={{ resize: 'vertical' }}
            />
          </div>
          {status === 'error' && (
            <p className="field-error">Something went wrong. Please try again.</p>
          )}
          <button type="submit" className="button" style={{ width: '100%' }} disabled={status === 'sending'}>
            {status === 'sending' ? 'Sending...' : 'Send Message'}
          </button>
          {status === 'success' && (
            <p className="field-success" style={{ marginTop: '12px' }}>Message sent! I'll get back to you soon.</p>
          )}
        </form>
      </div>
    </div>
  );
}

export default Support;
